import React from 'react';
import { bool } from 'prop-types';

import './browse-callout.scss';

export const BrowseCallout = ({ isAVehicle = false, isDelivery = false }) => {
  return (
    <div className="browse-callout">
      Browse {isAVehicle ? 'vehicle' : 'tool'} availability up to {isDelivery ? '6 months' : '30 days'} in advance.
    </div>
  );
};

BrowseCallout.propTypes = {
  isAVehicle: bool,
  isDelivery: bool
};

BrowseCallout.defaultProps = {
  isAVehicle: false,
  isDelivery: false
};